import React from "react";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import './PageLayout.css';
import globals from '../Globals'
import AdminsPage from "../Pages/AdminsPage";
import DatabasePage from "../Pages/DatabasePage";
import AssetsPage from "../Pages/AssetsPage";
import TestPage from "../Pages/TestPage";
import EventBus from "../EventBus";
import ConfirmLogoutDialog from './ConfirmLogoutDialog';
import AssetInspector from "../Pages/AssetInspector";
import MachineSpecs from "../Pages/MachineSpecs";
import DeployPage from "../Pages/DeployPage"; // Adjust path as needed

const Page = {
    Home: { id: 0, title: "Home", subs: {} },
    Players: { id: 1, title: "Players", subs: {} },
    Servers: { id: 2, title: "Game Servers", subs: {
        Overview: { id: 0, title: "Overview" },
        Machines: { id: 1, title: "Machine Specs" },
        Scaling: { id: 2, title: "Scaling Rules" },
        Deploy: { id: 3, title: "Manual Deploy" },
        Logs: { id: 4, title: "Logs" },
    }},
    Database: { id: 3, title: "Database", subs: {
        Versioning: { id: 0, title: "Versioning" },
        Assets: { id: 1, title: "Asset Manager" },
        AssetInspector: { id: 2, title: "Asset Inspector" }
    }},
    Admins: { id: 4, title: "Admins", subs: {} },
    Test: { id: 5, title: "Test", subs: {} }
}

export default class PageLayout extends React.Component {
    state = {
        currentPage: Page.Home.id,
        currentSub: 0,
        menuOpen: true,
        confirmLogoutOpen: false,
    }

    closeConfirmDialog = () => {
        this.setState({ confirmLogoutOpen: false });
    }

    handleLogout = () => {
        this.setState({ confirmLogoutOpen: false }, () => {
            EventBus.emit("logout", false);
        });
    }

    handleForgetAndLogout = () => {
        this.setState({ confirmLogoutOpen: false }, () => {
            EventBus.emit("logout", true);
        });
    }

    toggleMenu = () => {
        this.setState({ menuOpen: !this.state.menuOpen });
    }

    buttonClicked = (page, sub) => {
        this.setState({ currentPage: page, currentSub: sub });

        const newHash = `${page}-${sub}`;
        window.location.hash = newHash;
    }

    generateButtons(){
        let buttons = [];

        for (const page of Object.values(Page)) {
            let active = this.state.currentPage === page.id;

            let classes = "side-menu-button";
            if (active) classes += " side-menu-button-current";

            buttons.push(
                <div key={page.id} className={classes} onClick={() => this.buttonClicked(page.id, 0)}>
                    <div><span>{page.title}</span></div>
                </div>
            );

            if (active) {
                for (const sub of Object.values(page.subs)) {
                    let key = page.id + "-" + sub.id;

                    let subClasses = "side-menu-button side-submenu-button";
                    if (this.state.currentSub === sub.id) subClasses += " side-menu-button-current";

                    buttons.push(
                        <div key={key} className={subClasses} onClick={() => this.buttonClicked(page.id, sub.id)}>
                            <div><span>{sub.title}</span></div>
                        </div>
                    );
                }
            }
        }

        return buttons;
    }

    generateMenu = () => {
        if (this.state.menuOpen) {
            return (
                <div id="side-menu">
                    {this.generateButtons()}
                </div>
            );
        } else {
            return (<></>);
        }
    }

    routePage() {
        switch (this.state.currentPage) {
            case Page.Home.id:
                return <h2>Overview</h2>;
            case Page.Servers.id:
                switch (this.state.currentSub) {
                    case Page.Servers.subs.Overview.id:
                        return <h2>Servers Overview</h2>;
                    case Page.Servers.subs.Machines.id:
                        return <MachineSpecs key="MachineSpecs" />;
                    case Page.Servers.subs.Scaling.id:
                        return <h2>Scaling</h2>;
                    case Page.Servers.subs.Deploy.id:
                        return <DeployPage key="DeployPage" />;
                    case Page.Servers.subs.Logs.id:
                        return <h2>Logs</h2>;
                    default:
                        return <h2>Servers: Empty Page</h2>;
                }
            case Page.Database.id:
                switch (this.state.currentSub) {
                    case Page.Database.subs.Versioning.id:
                        return <DatabasePage key="databasePage" />;
                    case Page.Database.subs.Assets.id:
                        return <AssetsPage key="assetsPage" />;
                    case Page.Database.subs.AssetInspector.id:
                        return <AssetInspector key="assetInspector" />;
                    default:
                        return <h2>Database: Empty Page</h2>;
                }
            case Page.Admins.id:
                return <AdminsPage key="adminsPage" />;
            case Page.Test.id:
                return <TestPage key="testPage" />;
            default:
                return <h2>Empty Page</h2>;
        }
    }

    render() {
        return (
            <>
                <div id="top-menu">
                    <IconButton
                        id="top-menu-button"
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        style={{ marginRight: '12px' }}
                        onClick={this.toggleMenu}
                    >
                        <MenuIcon />
                    </IconButton>
                    <span id="top-menu-title">Huge Loot</span>
                    <span id="top-menu-logout" onClick={() => this.setState({ confirmLogoutOpen: true })}>
                        Logout
                    </span>
                    <span id="top-menu-email">{globals.loginData.email}</span>
                </div>
                {this.generateMenu()}
                <div
                    id="page-content"
                    align="center"
                    className={this.state.menuOpen ? "page-content-margin" : ""}
                >
                    {this.routePage()}
                </div>
                <ConfirmLogoutDialog
                    open={this.state.confirmLogoutOpen}
                    onClose={this.closeConfirmDialog}
                    onLogout={this.handleLogout}
                    onForgetAndLogout={this.handleForgetAndLogout}
                />
            </>
        );
    }

    componentDidMount() {
        window.addEventListener("hashchange", this.handleHashChange);
        this.handleHashChange();
    }

    componentWillUnmount() {
        window.removeEventListener("hashchange", this.handleHashChange);
    }

    handleHashChange = () => {
        const hash = window.location.hash.replace("#", "");
        const [pageStr, subStr] = hash.split("-");
        const page = parseInt(pageStr) || Page.Home.id;
        const sub = parseInt(subStr) || 0;
        this.setState({ currentPage: page, currentSub: sub });
    }
}